const keyFactory = {
  user: (userId?: string) => ["auth", userId],
  currentUser: () => keyFactory.user("me"),
  currentUserIdToken: () => [...keyFactory.user("me"), "idToken"],
  currentSession: (..._: unknown[]) => ["session"],
};

export default keyFactory;
